module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/login-banner/login-banner.component.scss
// module id = ./src/app/+app-custom/components/login-banner/login-banner.component.scss
// module chunks = main